export function findMergeTags(text: string, prefix: string, suffix: string): any[] | null {
  /*
   * Maybe find a better name, as it returns not only merge tags, but the entire text tokenized.
   */
  if (!prefix.length || !suffix.length) {
    return null;
  }
  /*
   * Regex e.g.
   * - prefix: {{, suffix: }} => regex: /{{[^}]+}}/
   * TODO - improve regex
   */
  const regex = RegExp(`${prefix}([^${suffix[0]}]+)${suffix}`, 'g');
  const tokens: any[] = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    const word = match[0]; // word with suffix and prefix included
    const startIndex = match.index;
    const endIndex = startIndex + word.length;

    // Add text before the match
    if (match.index > lastIndex) {
      tokens.push({
        text: text.substring(lastIndex, match.index),
        startIndex: lastIndex,
        endIndex: match.index,
        isMergeTag: false,
      });
    }

    // Add the matched word
    tokens.push({text: word, startIndex, endIndex, isMergeTag: true});

    lastIndex = endIndex;
  }

  if (!tokens.length) {
    // nothing was matched
    return null;
  }

  // Add the remaining text if any
  if (lastIndex < text.length) {
    tokens.push({
      text: text.substring(lastIndex),
      startIndex: lastIndex,
      endIndex: text.length,
      isMergeTag: false,
    });
  }
  return tokens;
}
